$(function() {
    "use strict";

    var $form = $('.form-vertical');
    var $calendarField = $form.find('.form-vertical__calendar');
    if ($calendarField.length) {
        $calendarField.each(function() {
            var picker = new Pikaday({
                field: $(this)[0],
                format: 'YYYY-MM-DD',
                minDate: new Date($(this).data('minDate')),
                maxDate: new Date($(this).data('maxDate')),
                firstDay: 1,
                i18n: {
                    previousMonth : 'Прошлый месяц',
                    nextMonth     : 'Следующий месяц',
                    months        : ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
                    weekdays      : ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
                    weekdaysShort : ['Вс','Пн','Вт','Ср','Чт','Пт','Сб']
                }
            });
        });
    }
});